import React, { useEffect, useState } from 'react';
//import logo from './logo.svg';
import './AttachedFilesContainer.css';
import Dropzone from 'react-dropzone';

import * as model from 'models';
import * as api from '../../lib/api';
import * as notifications from 'lib/notifications';
import Timestamp from 'components/Common/Timestamp';
import UserDtoView from 'components/Common/UserDtoView';

interface IAppProps {
  fakturaId: string;
  userId: number;
}

function fileIsViewable(value: model.AttachedFileDto) {
  return value.fileName?.endsWith("pdf");
}

function AttachedFilesContainer(props: IAppProps) {
  //console.log("AttachedFilesContainer");

  const [files, setFiles] = useState<model.AttachedFileDto[]>(null);

  useEffect(() => {
    // Update the document title using the browser API
    refreshFileList();
  }, []);

  const [uploadFile, setUploadFile] = React.useState<File[]>();

  useEffect(() => {
    // Update the document title using the browser API
    //console.log("useEffect called, uploadedFile changed!");
    if (uploadFile != null) {
      api.supplierInvoiceAttachedFilesPost(props.fakturaId, uploadFile).then(data => {
        //console.log("supplierInvoiceAttachesFilesPost() got data", data);
        // Seems like it mostly never returns anything from this function. Why?
        if (data && data.value) {
          const newfiles = [...files, data.value]
          setFiles(newfiles);
        }
        notifications.dispatch("Filen bifogades", 3);
        updateNrOfAttachedFiles(data);
        refreshFileList();
        setUploadFile(null);
      }).catch((reason) => {
        //console.log("supplierInvoiceAttachedFilesPost catch", reason);
        notifications.dispatchFromError("Fel vid uppaddning av fil", reason);
      });
    }
  }, [uploadFile]);

  return (
    <div className="row">
      <div className="col-sm-12 files">
        <fieldset>
          <legend>Bifogade filer</legend>

          <table className="table table-striped table-condensed table-hover table-responsive filesTable">
            <thead>
              <tr>
                <th>Filnamn</th>
                <th>Skapad</th>
                <th colSpan={3}>Skapad av</th>
              </tr>
            </thead>
            <tbody>
              {files && files.map((value, index) => (
                <tr key={value.id}>
                  <td>
                    <a href={api.supplierInvoiceAttachedFilesGet(props.fakturaId, value.id, fileIsViewable(value))} target="_blank">
                      {value.fileName}
                    </a>
                  </td>
                  <td><Timestamp value={value.created} /></td>
                  <td><UserDtoView value={value.createdBy} /></td>
                  <td>
                    <a href={api.supplierInvoiceAttachedFilesGet(props.fakturaId, value.id)} target="_blank">Ladda ner</a>
                    {fileIsViewable(value) &&
                      <>
                        &nbsp;
                        <a href={api.supplierInvoiceAttachedFilesGet(props.fakturaId, value.id, true)} target="_blank">Visa</a>
                      </>
                    }
                    {value.createdBy?.id == props.userId &&
                      <>
                        &nbsp;<button type="button" className="btn btn-link" onClick={() => { deleteFile(value); }}>Ta bort</button>
                      </>
                    }

                  </td>
                </tr>
              ))}
            </tbody>


          </table>
        </fieldset>

        <fieldset>
          <legend>Bifoga ny fil</legend>

          <Dropzone onDrop={acceptedFiles => {
            //console.log("acceptedFiles", acceptedFiles);
            setUploadFile(acceptedFiles);
          }}>
            {({ getRootProps, getInputProps }) => (
              <section className="dropzoneContainer">
                <div {...getRootProps({ className: 'dropzone' })}>
                  <input {...getInputProps()} />
                  <p>Dra filen hit eller klicka för att välja filer...</p>
                </div>
              </section>
            )}
          </Dropzone>

        </fieldset>
      </div>
    </div>

  );

  function refreshFileList() {
    api.supplierInvoiceAttachedFilesList(props.fakturaId).then(data => {
      //console.log("got data", data);
      setFiles(data);
    }).catch((reason) => {
      //console.log("catch", reason);
    });
  }

  function updateNrOfAttachedFiles(data: model.SupplierInvoiceAttachedFilesDeleteResponse) {
    if (data) {
      const els = document.querySelectorAll("#menyPageInternal .menuNrOfAttachedFilesCounter");
      els.forEach(el => {el.innerHTML = data.nrOfAttachedFiles.toString()})
    }
    api.webSessionUpdate({cmdType: model.SessionUpdateCmdType.UppdateraAntalBifogadeFiler}).then(d => {
      //console.log("web session updated");
    });
  }

  function deleteFile(value: model.AttachedFileDto) {
    //console.log("deleteFile");
    api.supplierInvoiceAttachedFilesDelete(props.fakturaId, value.id).then(data => {
      //console.log("got data", data);
      notifications.dispatch("Filen togs bort", 3);
      updateNrOfAttachedFiles(data);
      refreshFileList();
    }).catch((reason) => {
      //console.log("catch", reason);
      notifications.dispatchFromError("Fel vid borttagning av fil", reason);
    });
  }
}

export default AttachedFilesContainer;
